import Request from './base/Request';
import * as base64 from 'base-64';

class FindIdentityRequest extends Request {
    constructor(APIURL, phoneNumber) {
        super(APIURL);

        this.options = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({phoneNumber})
        };

        this.request = this.request.bind(this);
    }
}

export default FindIdentityRequest;
